import { useVerdictNotification } from "@/entities/notification/api";
import { Button } from "@/shared/ui/button";
import { Spinner } from "@/shared/ui/spinner";

interface VerdictNotificationButtonsProps {
  id: string;
}

export const VerdictNotificationButtons = ({
  id,
}: VerdictNotificationButtonsProps) => {
  const { mutateAsync, status } = useVerdictNotification();

  const handleVerdictNotification = async (verdict: boolean) => {
    try {
      await mutateAsync({ id, verdict });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Button
        disabled={status === "pending"}
        onClick={() => handleVerdictNotification(true)}
      >
        {status === "idle" ? "Принять" : <Spinner />}
      </Button>
      <Button
        disabled={status === "pending"}
        onClick={() => handleVerdictNotification(true)}
        variant="destructive"
      >
        {status === "idle" ? "Отклонить" : <Spinner />}
      </Button>
    </>
  );
};
